import { render, staticRenderFns } from "./LanguagesHome.vue?vue&type=template&id=99a2d5b6&scoped=true&"
import script from "./LanguagesHome.vue?vue&type=script&lang=js&"
export * from "./LanguagesHome.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesHome.vue?vue&type=style&index=0&id=99a2d5b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a2d5b6",
  null
  
)

export default component.exports